import reframe from 'reframe.js';

export default () => {
  reframe('.text-block iframe');
  // eslint-disable-next-line
  console.log('reframe');
};
